<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="500px"
  >
    <template v-slot:activator="{ on }">
      <v-btn
        small
        icon
        color="primary"
        v-on="on"
      >
        <v-icon>
          mdi-pencil
        </v-icon>
      </v-btn>
    </template>

    <material-card
      :offset="10"
      :full-width="true"
      color="hrissecondary"
      title="Value of Living Accomodation"
      text="Update Value of Living Accomodation"
      class="mb-0"
    >
      <v-container v-if="dialog">
        <v-row>
          <v-col
            cols="12"
            class="pb-0"
          >
            <v-autocomplete
              v-model="localVola.benefit_in_kind_id"
              v-validate="'required'"
              :items="benefitInKinds"
              item-text="name"
              item-value="id"
              label="Value of Living Accomodation"
              :error-messages="errors.collect('benefit_in_kind_id')"
              data-vv-name="benefit_in_kind_id"  
              data-vv-as="value of living accomodation"
              outlined
            />
          </v-col>

          <v-col
            cols="12"
            class="pb-0"
          >
            <v-text-field
              v-model="localVola.amount"
              v-money="money"
              label="Amount"
              prefix="RM"
              outlined
            />
          </v-col>

          <v-col
            cols="12"
            class="pb-0"
          >
            <v-textarea
              v-model="localVola.address"
              v-validate="'required'"
              :error-messages="errors.collect('address')"
              label="Address"
              auto-grow
              data-vv-name="address"
              outlined
              rows="3"
              row-height="25"
              outline
            />
          </v-col>

          <v-col
            cols="12"
            class="pb-0"
          >
            <v-menu
              v-model="startDateMenu"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              min-width="290px"
              max-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="startDateDisplay"
                  v-validate="'required'"
                  :error-messages="errors.collect('startDateDisplay')"
                  data-vv-name="startDateDisplay"
                  data-vv-as="start date"
                  label="Start date"
                  outlined
                  readonly
                  class="label-position"
                  v-on="on"
                >
                  <template v-slot:prepend-inner>
                    <v-icon>
                      mdi-calendar
                    </v-icon>
                  </template>
                </v-text-field>
              </template>
              <v-date-picker
                v-model="localVola.start_date"
                no-title
                :min="companyEmployeeStartDate"
                @input="startDateMenu = false"
              />
            </v-menu> 
          </v-col>

          <v-col
            cols="12"
          >
            <v-menu
              v-model="endDateMenu"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              min-width="290px"
              max-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="endDateDisplay"
                  data-vv-name="endDateDisplay"
                  data-vv-as="end date"
                  label="End date"
                  readonly
                  outlined
                  class="label-position"
                  v-on="on"
                >
                  <template v-slot:prepend-inner>
                    <v-icon>
                      mdi-calendar
                    </v-icon>
                  </template>
                </v-text-field>
              </template>
              <v-date-picker
                v-model="localVola.end_date"
                no-title
                :min="localVola.start_date"
                @input="endDateMenu = false"
              />
            </v-menu>
          </v-col>
        </v-row>
      </v-container>

      <v-card-actions>
        <v-spacer />
        <v-btn
          text
          class="px-10"
          @click="dialog = false"
        >
          Close
        </v-btn>
        <v-btn
          color="hrissecondary"
          class="px-10 white--text"
          :loading="progressing"
          @click="submitForm"
        >
          Update
        </v-btn>
      </v-card-actions>
    </material-card>
  </v-dialog>
</template>

<script>
  import { VMoney } from 'v-money'

  export default {
    $_veeValidate: {
      validator: 'new', 
    },
    directives: { money: VMoney },
    props: {
      vola: {
        type: Object,
        default: null,
        required: true,
      },
      companyEmployeeStartDate: {
        type: String,
        required: true,
      },
    },

    data () {
      return {
        dialog: false,
        progressing: false,
        startDateMenu: false,
        endDateMenu: false,
        localVola: null,
        benefitInKinds: [],
        money: {
          decimal: '.',
          thousands: ',',
          precision: 2,
          masked: false, /* doesn't work with directive */
        },
      }
    },

    computed: {
      startDateDisplay () {
        return this.localVola.start_date ? this.$moment(this.localVola.start_date, 'YYYY-MM-DD').format('DD-MM-YYYY') : ''
      },
      endDateDisplay () {
        return this.localVola.end_date ? this.$moment(this.localVola.end_date, 'YYYY-MM-DD').format('DD-MM-YYYY') : ''
      },
    },

    watch: {
      dialog: function (val) {
        if (!val) return 

        this.localVola = { ...this.vola }
        if (this.localVola.amount) this.localVola.amount = (Math.round((this.localVola.amount / 100) * 100) / 100).toFixed(2)
        
        this.$api.benefitInKinds().list('?filter[type]=vola')
          .then(res => {
            this.benefitInKinds = _.orderBy(res.data, ['name'], ['asc'])

            this.loading = false
          })
      },
    },

    methods: {
      submitForm () {
        this.$validator.validateAll()
          .then(result => {
            if (!result) return

            this.progressing = true
            
            this.$api.companyEmployeeVolas().update(this.localVola.id, this.prepareFormData())
              .then(res => {
                this.$emit('updated')
                this.$snack({ message: res.data.status })

                this.dialog = false
                this.progressing = false
              })
          })
      },
      prepareFormData () {
        return { 
          start_date: this.localVola.start_date,
          benefit_in_kind_id: this.localVola.benefit_in_kind_id,
          amount: this.localVola.amount.toString().replaceAll(',', '') * 100,
          address: this.localVola.address,
          end_date: this.localVola.end_date,
        }
      },
    },
  }
</script>

<style scoped>
.label-position >>> .v-label.v-label--active{
  margin-left:-28px;
  background:white;
  padding-right:5px
}
</style>
